import {Contact} from './contact';
import {Bank} from './bank';
import {Address} from './address';

export class Contract {
    id:string;
    contractNumber:string;
    bank:Bank = new Bank();
    businessName:string;
    cuit:string;
    phone:string;
    address:Address = new Address(null);
    contacts:Contact[] = [];
    dueDate:string;

    constructor(other?:Contract) {
        if (other) {
            this.id = other.id;
            this.contractNumber = other.contractNumber;
            this.bank = other.bank;
            this.businessName = other.businessName;
            this.cuit = other.cuit;
            this.phone = other.phone;
            this.address = new Address(other.address);
            this.contacts = other.contacts;
        }
    }

    public getContact() {
        if (this.contacts && this.contacts.length > 0) {
            return this.contacts[0];
        }
        return null;
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/contract.ts
 **/